import React, { useEffect } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from '@expo/vector-icons';
import { AuthProvider, useAuth } from '../context/AuthContext';
import { notificationService } from '../services/notificationService';

// Import screens
import LoginScreen from '../screens/auth/LoginScreen';
import RegisterScreen from '../screens/auth/RegisterScreen';
import ForgotPasswordScreen from '../screens/auth/ForgotPasswordScreen';
import MapScreen from '../screens/map/MapScreen';
import RequestRideScreen from '../screens/ride/RequestRideScreen';
import BookLimousineScreen from '../screens/ride/BookLimousineScreen';
import CorporateRegistrationScreen from '../screens/corporate/CorporateRegistrationScreen';
import TrackDriverScreen from '../screens/ride/TrackDriverScreen';
import RateRideScreen from '../screens/ride/RateRideScreen';
import RideHistoryScreen from '../screens/ride/RideHistoryScreen';
import ProfileScreen from '../screens/profile/ProfileScreen';
import LoadingScreen from '../screens/LoadingScreen';

const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();

const MainTabs = () => (
  <Tab.Navigator
    screenOptions={({ route }) => ({
      tabBarIcon: ({ focused, color, size }) => {
        const icons = { Map: 'map', History: 'time', Profile: 'person' };
        const iconName = focused ? icons[route.name] : `${icons[route.name]}-outline`;
        return <Ionicons name={iconName} size={size} color={color} />;
      },
      tabBarActiveTintColor: '#000000',
      tabBarInactiveTintColor: '#666666',
      tabBarStyle: { backgroundColor: '#ffffff', borderTopColor: '#E0E0E0' },
      headerStyle: { backgroundColor: '#000000' },
      headerTintColor: '#ffffff',
      headerTitleStyle: { fontWeight: 'bold' },
    })}
  >
    <Tab.Screen name="Map" component={MapScreen} options={{ title: 'Obzidn', headerShown: false }} />
    <Tab.Screen name="History" component={RideHistoryScreen} options={{ title: 'Ride History' }} />
    <Tab.Screen name="Profile" component={ProfileScreen} options={{ title: 'Profile' }} />
  </Tab.Navigator>
);

const AppContent = () => {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (user) {
      notificationService.registerForPushNotifications()
        .then(token => {
          if (token) console.log('[Rider] Push token registered');
        })
        .catch(err => console.warn('[Rider] Push registration failed:', err.message));
    }
  }, [user]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerStyle: { backgroundColor: '#000000' },
          headerTintColor: '#ffffff',
          headerTitleStyle: { fontWeight: 'bold' },
        }}
      >
        {user ? (
          <>
            <Stack.Screen name="MainTabs" component={MainTabs} options={{ headerShown: false }} />
            <Stack.Screen name="RequestRide" component={RequestRideScreen} options={{ title: 'Request Ride', presentation: 'modal' }} />
            <Stack.Screen name="BookLimousine" component={BookLimousineScreen} options={{ title: 'Book Limousine', presentation: 'modal' }} />
            <Stack.Screen name="CorporateRegistration" component={CorporateRegistrationScreen} options={{ title: 'Corporate Account', presentation: 'modal' }} />
            <Stack.Screen name="TrackDriver" component={TrackDriverScreen} options={{ title: 'Track Driver', headerLeft: () => null, gestureEnabled: false }} />
            <Stack.Screen name="RateRide" component={RateRideScreen} options={{ title: 'Rate Ride', headerLeft: () => null, gestureEnabled: false }} />
            <Stack.Screen name="RideHistory" component={RideHistoryScreen} options={{ title: 'Ride History' }} />
          </>
        ) : (
          <>
            <Stack.Screen name="Login" component={LoginScreen} options={{ headerShown: false }} />
            <Stack.Screen name="Register" component={RegisterScreen} options={{ title: 'Create Account' }} />
            <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: 'Reset Password' }} />
          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};

const AppNavigator = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default AppNavigator;
